var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1764 24.0646H38.5013C30.5281 24.0568 24.0582 30.514 24.0502 38.4872C24.0478 40.9637 24.6824 43.3991 25.8931 45.5594L8.05566 14.9533C21.0478 -1.86189 45.2115 -4.961 62.0266 8.03111C67.4268 12.2035 71.6201 17.7372 74.1764 24.0646Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5013C76.9823 59.756 59.7564 76.9818 38.5017 76.9996C36.892 77.0056 35.284 76.8984 33.6895 76.6788L51.0137 45.7197C54.9843 38.8075 52.6174 29.9858 45.7202 25.9894C43.5364 24.7251 41.0571 24.0609 38.5338 24.0645H74.1767C76.0502 28.6467 77.0094 33.551 77 38.5013Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0133 45.72L33.689 76.679H33.657C12.575 74.0154 -2.35602 54.7657 0.307582 33.6837C1.16973 26.86 3.84521 20.3922 8.05566 14.9534L25.8931 45.5595L25.9894 45.72C29.9672 52.6301 38.7935 55.0072 45.7037 51.0296C47.911 49.759 49.7428 47.9271 51.0133 45.72Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0135 45.7199C47.0357 52.63 38.2094 55.0072 31.2992 51.0295C29.092 49.7589 27.2602 47.9271 25.9896 45.7199L25.8934 45.5594C21.9953 38.604 24.4739 29.8055 31.4293 25.9074C33.5897 24.6967 36.0252 24.0621 38.5016 24.0645H38.5336C41.0569 24.0609 43.5363 24.7251 45.72 25.9894C52.6173 29.986 54.9841 38.8077 51.0135 45.7199Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0135 45.7199C47.0357 52.63 38.2094 55.0072 31.2992 51.0295C29.092 49.7589 27.2602 47.9271 25.9896 45.7199L25.8934 45.5594C21.9953 38.604 24.4739 29.8055 31.4293 25.9074C33.5897 24.6967 36.0252 24.0621 38.5016 24.0645H38.5336C41.0569 24.0609 43.5363 24.7251 45.72 25.9894C52.6173 29.986 54.9841 38.8077 51.0135 45.7199Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4466 54.5425C35.6497 54.5422 32.9022 53.8052 30.4806 52.4059C28.0388 50.9936 26.0109 48.9647 24.6 46.5221C20.1704 38.8498 22.7991 29.0394 30.4714 24.6098C32.9126 23.2004 35.6822 22.4592 38.5012 22.4607C47.3603 22.4538 54.5477 29.6301 54.5545 38.4892C54.5567 41.3092 53.8153 44.0799 52.4054 46.5221C49.5144 51.4923 44.1963 54.548 38.4466 54.5425ZM38.5299 25.6688C33.9262 25.6443 29.664 28.0945 27.3685 32.0853C23.8249 38.23 25.9334 46.0841 32.0781 49.6277C38.2228 53.1713 46.0769 51.0628 49.6205 44.9181C53.1642 38.7804 51.0612 30.932 44.9235 27.3882C42.9802 26.2663 40.7768 25.6735 38.533 25.669H38.5299V25.6688Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.2624ee040149e12571dd1932026ca297.svg";
export { ForwardRef as ReactComponent };